import { ReportHandler } from 'web-vitals';
import { initPerformanceMonitoring, observeLongTasks } from './utils/performance';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  } else {
    // Initialize our custom performance monitoring
    initPerformanceMonitoring();
    observeLongTasks();
  }
};

export default reportWebVitals;
